import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { ApolloConsumer } from '@apollo/client';
import { Helmet } from 'react-helmet-async';
//components
import TopBarUserBack from './common/TopBarUserBack';
import UserForm from './NewUser/UserForm';
import UserFormProvider from './UserFormProvider'
import NotAuthorized from './NotAuthorized';

const useStyles = makeStyles(() => ({
    root:{

    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
    },
}));
const UpdateUser = ({  match }) => {
    const classes = useStyles();
    const userId = match.params.id !== 'undefined' ? match.params.id : ''
    return (
        <ApolloConsumer>
            {
                apolloClient => {
                    return (
                        <UserFormProvider apolloClient={apolloClient} userid={userId}>
                            <Helmet>
                                <title>Riverside Takeoffs :: Update User</title>
                            </Helmet>
                            <div className={classes.root}>
                                <TopBarUserBack title="New User"/>
                                {
                                    localStorage.getItem('role') === 'admin' ?
                                        <UserForm/> :
                                        <NotAuthorized />
                                }
                            </div>
                        </UserFormProvider>
                    )
                }
            }
        </ApolloConsumer>
    )
}

export default UpdateUser